export const ITEM_PER_PAGE = 20;
export const ROOT_APP = '/';
export const REACT_QUERY_CONF_API = {
  keepPreviousData: true,
  staleTime: 20000,
};
